<template>
  <a-tree-select
    :value="value"
    allow-clear
    show-search
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :tree-data="afterRecords(records)"
    tree-node-filter-prop="title"
    @change="onChange"
    @clear="onClear"
    :class="class"
    :fieldNames="{ label: 'name', value: 'id' }"
  ></a-tree-select>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, toRaw } from "vue";
import { ProjectFundService } from "@/views/finance/project-fund/project-fund.service";
import { Item } from "ant-design-vue/lib/menu";

/**
 * 工程款科目选择器
 *
 * 使用方式
 * <project-fund-select v-model:value="formRef.projectFundId"></project-fund-select>
 */
export default defineComponent({
  name: "ProjectFundSelect",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },

    value: {
      type: String,
      default: undefined,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Boolean,
      default: false,
    },
    // 已选中的ID集合
    // 禁用当前节点和下级节点
    selectedIds: {
      type: Array,
      default: [],
    },
    class: {
      type: String,
      default: "append-to-body",
    },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = ProjectFundService.useSimpleListApi();

    const records = computed(() => {
      if (data.value) {
        return disableSiblingAndChildren(data.value?.records || []);
      }
      return [];
    });
    const afterRecords = (obj) => {
      if (props.level) {
        obj.forEach((item) => {
          if (item.children) {
            delete item.children;
          }
        });
        return obj;
      }
      return obj;
    };
    /**
     * 禁用同级和下级
     */
    const disableSiblingAndChildren = (records) => {
      records = toRaw(records) || [];
      const recursion = (list, disabled) => {
        return list.map((item) => {
          if (disabled) {
            item.disabled = true;
            if (item.children) {
              item.children = recursion(item.children, true);
            }
          } else {
            const isInclude = props.selectedIds.includes(item.id);
            item.disabled = isInclude;
            if (item.children) {
              item.children = recursion(item.children, isInclude);
            }
          }
          return item;
        });
      };
      return recursion(records, false);
    };

    const onChange = (id) => {
      emit("update:value", id);
      emit("change", id);
    };

    const onClear = () => {
      emit("update:value", "");
      emit("change", "");
    };

    onMounted(async () => {
      await run();
    });

    return {
      records,
      loading,
      onChange,
      onClear,
      run,
      afterRecords,
    };
  },
});
</script>
